import type { Token } from '@ui/models/token/model';
import { Fraction } from 'bi-fraction';

import type { TokenFetcher } from '../model';

type SupportedToken =
  | Token.ETH
  | Token.CRO
  | Token.LCRO
  | Token.FUL
  | Token.WBTC
  | Token.CorgiAI;

export const cdcFetcher: TokenFetcher<SupportedToken> = {
  support: (token): token is SupportedToken => token in TOKEN_HANDLE_MAP,
  fetch: async (token) => {
    const response = await (
      await fetch(
        `https://price-api.crypto.com/price/v1/token-price/${TOKEN_HANDLE_MAP[token]}`,
      )
    ).json();
    if (!isFetchTokenPriceResponse(response))
      throw new Error(
        `Could not fetch ${token} asset price from price-api.crypto.com`,
      );
    return {
      usd_price: new Fraction(response.usd_price),
      usd_price_change_24h: new Fraction(response.usd_price_change_24h),
    };
  },
};

const TOKEN_HANDLE_MAP = {
  ETH: 'ethereum',
  CRO: 'cronos',
  LCRO: 'veno-finance',
  FUL: 'fulcrom-finance',
  WBTC: 'bitcoin',
  CorgiAI: 'corgiai',
} as const satisfies Record<SupportedToken, string>;

/**
 * Response from the CDC API
 */
const isFetchTokenPriceResponse = (
  response: unknown,
): response is {
  slug: string;
  usd_price: number;
  usd_price_change_24h: number;
} => {
  return (
    typeof response === 'object' &&
    response !== null &&
    'usd_price' in response &&
    typeof response.usd_price === 'number'
  );
};
